import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicalHistorySection = _resolveComponent("ClinicalHistorySection")!
  const _component_Immunization = _resolveComponent("Immunization")!
  const _component_ImplantableDeviceSection = _resolveComponent("ImplantableDeviceSection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ClinicalHistorySection, { class: "mb-2" }),
    _createVNode(_component_Immunization, { class: "mb-2" }),
    _createVNode(_component_ImplantableDeviceSection)
  ]))
}